import { computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import type { RouteMeta } from 'vue-router';

import { wxsdk } from './api.ts';
import { sdkHook } from './index.ts';
import { wxConfig } from './lib.ts';

function hideMenuItems({
  AppMessageShare,
  TimelineShare,
  Favorite,
}: {
  AppMessageShare?: boolean;
  TimelineShare?: boolean;
  Favorite?: boolean;
}) {
  wxsdk.showAllNonBaseMenuItem();

  const menuList: Parameters<(typeof wxsdk)['hideMenuItems']>[0]['menuList'] = [
    ...(TimelineShare === false ? ['menuItem:share:timeline' as const] : []),
    ...(AppMessageShare === false
      ? ['menuItem:share:appMessage' as const]
      : []),
    ...(Favorite === false ? ['menuItem:favorite' as const] : []),
    'menuItem:copyUrl',
    'menuItem:openWithQQBrowser',
    'menuItem:openWithSafari',
    'menuItem:originPage',
    'menuItem:readMode',
    'menuItem:share:email',
    'menuItem:share:facebook',
    'menuItem:share:qq',
    'menuItem:share:QZone',
    'menuItem:share:weiboApp',
  ];

  wxsdk.hideMenuItems({
    menuList,
  });
}

function runHook({
  AppMessageShare = false,
  TimelineShare = false,
  Favorite = false,
}) {
  sdkHook()
    .then((tmp) => {
      hideMenuItems({ AppMessageShare, TimelineShare, Favorite });

      if (AppMessageShare === undefined) {
        tmp.updateAppMessageShareData();
      }

      if (TimelineShare === undefined) {
        tmp.updateTimelineShareData();
      }
    })
    .catch(console.error);
}

function afterWechatConfig({
  AppMessageShare = true,
  TimelineShare = true,
  Favorite = false,
  jsApiList = [],
  openTagList = [],
}: RouteMeta['wechat'] = {}) {
  wxConfig({
    openTagList,
    jsApiList: [
      ...jsApiList,
      'showAllNonBaseMenuItem' as const,
      'hideMenuItems' as const,
      AppMessageShare === false
        ? undefined
        : ('updateAppMessageShareData' as const),
      TimelineShare === false
        ? undefined
        : ('updateTimelineShareData' as const),
    ].filter((item) => item !== undefined),
  })
    .then(() => {
      runHook({ AppMessageShare, TimelineShare, Favorite });
    })
    .catch(console.error);
}

export function usePageConfig() {
  const route = useRoute();

  const fullPath = computed(() => route.fullPath);
  watch(
    fullPath,
    (newPath, oldPath) => {
      if (
        !import.meta.env.WATCHING &&
        newPath &&
        newPath !== '/' &&
        newPath !== oldPath
      ) {
        afterWechatConfig(route.meta?.wechat);
      }
    },
    { immediate: true },
  );
}
